import { render, staticRenderFns } from "./fcGoodsDetail.vue?vue&type=template&id=085d210d&"
import script from "./fcGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./fcGoodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports